import * as React from 'react'
import { SVGProps } from 'react'
const SvgStraighten = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height={24}
    viewBox="0 -960 960 960"
    width={24}
    fill="#5f6368"
    {...props}
  >
    <path d="M160-240q-33 0-56.5-23.5T80-320v-320q0-33 23.5-56.5T160-720h640q33 0 56.5 23.5T880-640v320q0 33-23.5 56.5T800-240H160Zm0-80h640v-320H680v160h-80v-160h-80v160h-80v-160h-80v160h-80v-160H160v320Zm120-160h80-80Zm160 0h80-80Zm160 0h80-80Zm-120 0Z" />
  </svg>
)
export default SvgStraighten
